export default "__VITE_ASSET__ZcJfNA3o__";